import { render, staticRenderFns } from "./IPList.vue?vue&type=template&id=07696ab0&"
import script from "./IPList.vue?vue&type=script&lang=js&"
export * from "./IPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports